import { Link, useNavigate, useParams } from 'react-router-dom'
import { Table, useApiQuery, type Column } from 'grabbitbot-legacy-ui'
import { screenerClient } from '../../api'
import type { IndicatorCondition } from '../../api/types'

/** Equivalent of legacy `IndicatorconditionListComponent` (audit §3/§6). */
export function IndicatorconditionListPage() {
  const { exchangeId = '', tradingType = '' } = useParams<{ exchangeId: string; tradingType: string }>()
  const navigate = useNavigate()
  const { data, loading, error, refetch } = useApiQuery(
    () => screenerClient.searchIndicatorconditions(exchangeId, tradingType),
    [exchangeId, tradingType],
  )

  async function remove(id: string) {
    await screenerClient.deleteIndicatorcondition(exchangeId, tradingType, id)
    refetch()
  }

  const columns: Column<IndicatorCondition>[] = [
    {
      key: 'name',
      label: 'Name',
      align: 'left',
      format: (_v, row) => <Link to={`/${exchangeId}/${tradingType}/indicatorconditions/${row.id}`}>{row.name}</Link>,
    },
    { key: 'indicator', label: 'Indicator', align: 'left' },
    { key: 'logic', label: 'Logic', align: 'left' },
    {
      key: 'id',
      label: '',
      sortable: false,
      format: (_v, row) => (
        <button type="button" onClick={() => row.id && remove(row.id)}>
          Delete
        </button>
      ),
    },
  ]

  return (
    <div>
      <div className="screener-page-title">
        <h1>
          Indicator conditions <small>({exchangeId} · {tradingType})</small>
        </h1>
        <button type="button" onClick={() => navigate(`/${exchangeId}/${tradingType}/indicatorconditions/new`)}>
          New condition
        </button>
      </div>
      {loading && <p>Loading…</p>}
      {error && <p role="alert">Could not load indicator conditions.</p>}
      {data && <Table columns={columns} rows={data} rowKey={(row, i) => row.id ?? i} initialSort={{ key: 'name', dir: 'asc' }} />}
    </div>
  )
}
